import { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import { Alert, Skeleton } from '@material-ui/lab'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { obtenerMovimientoCuentaCliente } from '../../../ducks/clientesDuck'
import { formatDinero } from "../../../utils/formatDinero"
import { FormatoFechaIso } from '../../../utils/FormatFecha'
import { useCalcularMontoMensual } from '../../../hooks/useCalcularMontoMensual'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import { orange } from '@material-ui/core/colors'
import { Tooltip } from "@material-ui/core"
import { catTipoPago } from '../../../constant/catTipoPago'

const useStyles = makeStyles({
    root: {
        width: '100%',
        padding: '0'
    },
    container: {
        maxHeight: 440,
    },
})

export default function TPlanPagos() {
    const { referencia, cliente } = useSelector(store => store.cliente)
    const { mensualidades } = useCalcularMontoMensual({ IdPaquete: cliente.paquete?.Id_Paquete })
    const rows = mensualidades
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerMovimientoCuentaCliente({ referencia }))
    }, [dispatch, referencia])

    const classes = useStyles()
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    if (referencia === "")
        return (
            <div className="TarjetaClienta-root">
                <div className="contenido">
                    <Alert className="alerta" severity="info">Seleccione un cliente</Alert>
                    <Skeleton variant="rect" height={250} />
                </div>
            </div>
        )
    if (rows.length === 0)
        return (
            <div className="TarjetaClienta-root">
                <div className="contenido">
                    <Alert className="alerta" severity="info">No hay moviminetos para mostrar</Alert>
                </div>
            </div>
        )
    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">#</TableCell>
                            <TableCell align="center">Monto</TableCell>
                            <TableCell align="center">Monto por cubrir</TableCell>
                            <TableCell align="center">Fecha limite pago</TableCell>
                            <TableCell align="center">Pagado</TableCell>
                            <TableCell align="center">Tipo</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {mensualidades.map((row, index) => (
                            <TableRow key={row.IdPlanPago}>
                                <TableCell align="center">
                                    {index + 1}
                                </TableCell>
                                <TableCell align="center">
                                    {`${formatDinero(row.Monto)} ${row?.Moneda?.Clave}`}
                                </TableCell>
                                <TableCell align="center">
                                    {`${formatDinero(row?.MontoFaltante)} ${row?.Moneda?.Clave}`}
                                </TableCell>
                                <TableCell align="center">
                                    {FormatoFechaIso({ date: row?.FechaLimitePago, formato: "dd/MM/yyyy" })}
                                </TableCell>
                                <TableCell align="center">
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexFlow: "column" }}>
                                        {
                                            (row?.Pagado) &&
                                            <Tooltip title="Cubierto">
                                                <CheckCircleIcon color='secondary' />
                                            </Tooltip>

                                        }
                                        {
                                            (!row?.Pagado) &&
                                            <Tooltip title="Aun no cubierto">
                                                <ErrorIcon style={{ color: orange[400] }} />
                                            </Tooltip>
                                        }
                                    </div>
                                </TableCell>
                                <TableCell align="center">
                                    {
                                        (row?.CatTipoPago.IdCatTipoPago === catTipoPago.PLAN_PAGOS) &&
                                        <div>CIE</div>
                                    }
                                    {
                                        (row?.CatTipoPago.IdCatTipoPago === catTipoPago.TARJETA_CREDITO) &&
                                        <div>TDC</div>
                                    }
                                    {
                                        (row?.CatTipoPago.IdCatTipoPago === catTipoPago.EXTRA) &&
                                        <div>EXTRA</div>
                                    }
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    )
}